import React, {Component, createRef} from 'react';
import Loading from './loading';
import request from '../request';
import Markdown from './markdown';
import downloadBlob from '../download_blob';

const ACCEPTED_FILE_EXTENSIONS = ['.pdf', '.txt', '.doc', '.docx', '.xml', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', '.jpg', '.jpeg', '.png', '.tiff'];

export default class OpenaiPlayground extends Component {
  constructor(props) {
    super(props);
    let convo = [];
    let display_convo = [];
    this.state = {convo, display_convo, input: ''};

    this.onInputChanged = this.onInputChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.submit = this.submit.bind(this);

    this.textInputRef = createRef();
    this.fileInputRef = createRef();
    this.sessionFileInputRef = createRef();
  }

  componentDidMount() {
    if (this.textInputRef.current) {
      this.textInputRef.current.focus();
    }
  }

  selectConfig(e) {
    let selected_config = e.target.value;
    this.setState({selected_config});
  }

  submitConfig(e) {
    e.preventDefault();

    let config = this.state.selected_config || this.props.configs[0].id;
    this.setState({config});
  }

  onSubmit(e) {
    e.preventDefault();
    let {input, convo, display_convo} = this.state;
    let message = {role: 'user', content: input}
    convo.push(message);
    display_convo.push(message);
    this.setState({display_convo, convo, input: ''}, this.submit);
  }

  onChangeFile(e) {
    this.setState({uploading_in_progress: true});
    let files = [...e.target.files];
    if (files.length === 0) return;

    let promises = files.map(file => {
      return toBase64(file).then(file_data => {
        if (file.type.startsWith('image')) {
          return {type: 'input_image', image_url: file_data};
        } else {
          return {file_data, type: 'input_file', filename: file.name};
        }
      });
    });

    Promise.all(promises).then(content => {
      let {convo, display_convo} = this.state;
      let message = {role: 'user', content: content};
      convo.push(message);
      display_convo.push({role: 'user', type: 'files', content: content});
      this.setState({convo, display_convo, uploading_in_progress: false});
    });
  }

  submit() {
    this.setState({loading: true});
    let {input, config, convo, display_convo} = this.state;
    let url = '/admin/openai_playground';
    request('PUT', url, {convo, config}).then(response => {
      if (response.success) {
        convo = convo.concat(response.raw_output);
        display_convo.push({role: 'assistant', content: response.response});
        this.setState({convo, display_convo, loading: false});
      } else {
        display_convo.push({role: 'assistant', content: response.error, type: 'error'});
        this.setState({display_convo, loading: false});
      }
    }).catch(error => {
      display_convo.push({role: 'assistant', content: error.error, type: 'error'});
      this.setState({display_convo, loading: false});
    });
  }

  exportSession(e) {
    let {convo, display_convo, config} = this.state;
    let session = {convo, display_convo, config};
    downloadBlob(JSON.stringify(session), 'session.json', 'text/json;encoding:utf-8');
  }

  importSession(e) {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.onload = (l) => {
      let raw = l.target.result;
      let {convo, display_convo, config} = JSON.parse(raw);
      this.setState({convo, display_convo, config, input: ''});
    };
    reader.readAsText(file);
  }

  showFileUpload(e) {
    e.preventDefault();
    this.fileInputRef.current.click();
  }

  onInputChanged(e) {
    let input = e.target.value;
    this.setState({input});
  }


  renderFileInput() {
    return (
      <div>
        <input id="file-input" type="file" multiple={true} accept={ACCEPTED_FILE_EXTENSIONS} style={{display: "none"}} onChange={e => this.onChangeFile(e)} ref={this.fileInputRef} />
        <button className="btn btn-default" onClick={e => this.showFileUpload(e)} ><span className="fa fa-paperclip"></span> Upload Files</button>
      </div>
    )
  }

  renderSubmitButton() {
    return (
      <div id="chat_buttons">
        {this.renderFileInput()}
        <button type="submit" className="btn btn-success" value="Submit">Submit <span className="fa fa-arrow-right"></span></button>
      </div>
    )
  }

  renderInput() {
    let {input} = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <textarea className="form-control" value={input} onChange={this.onInputChanged} ref={this.textInputRef}></textarea>
        {this.renderSubmitButton()}
      </form>
    )
  }

  renderDots() {
    let {loading} = this.state;
    if (!loading) return null;
    return (
      <div className="dots">'Processing' <p className="loading-dots"></p></div>
    )
  }

  renderImage(file, index) {
    return (
      <p key={index}>
        <a download={file.filename} href={file.imag_url} >
          <img src={file.image_url} style={{height: 120}} />
        </a>
      </p>
    )
  }

  renderDocument(file, index) {
    return (
      <p key={index}><span  className="fa fa-paperclip"></span>
        <a download={file.filename} href={file.file_data} >{file.filename}</a>
      </p>
    )
  }

  renderFileMessage(message) {
    return (
      <div className="file message user_message">
        {message.content.map((file, index)  => {
          if (file.type === 'input_image') {
            return this.renderImage(file, index);
          } else {
            return this.renderDocument(file, index);
          }
        })}
      </div>
    )
  }

  renderErrorMessage(message) {
    return (
      <div className="file message assistant_message">
        <strong>ERROR</strong>
        <p>{message.content}</p>
      </div>
    )
  }


  renderMessage(message) {
    if (message.type === 'files') return this.renderFileMessage(message);
    if (message.type === 'error') return this.renderErrorMessage(message);

    let className = `message ${message.role}_message`;
    return (
      <div className={className}>
        <Markdown text={message.content} />
      </div>
    )
  }

  renderConvo() {
    let {display_convo} = this.state;
    return (
      <div id="convo">
      {display_convo.map((message, index) => {
        let containerClassName = `message_container ${message.role}_message_container`;
        return (
          <div key={index} className={containerClassName}>
            {this.renderMessage(message)}
          </div>
        )
      })}
        {this.renderDots()}
      </div>
    );
  }

  renderConfig() {
    let {configs} = this.props;

    return (
      <div>
        <form onSubmit={e => this.submitConfig(e)}>
          <div className="form-group">
            <label>Configuration</label>
            <select className="form-control" onChange={e => this.selectConfig(e)}>
              {configs.map(config => {
                return <option key={config.id} value={config.id}>{config.name}</option>
              })}
            </select>
          </div>
          <input type="submit" className="btn btn-success" value="Submit"/>
        </form>
        <hr />
        <h3>You can import a session</h3>
        <button onClick={e => this.sessionFileInputRef.current.click()} className="btn btn-default">Import Session</button>
        <input type="file" accept=".json" style={{display: "none"}} onChange={e => this.importSession(e)} ref={this.sessionFileInputRef} />
      </div>
    )
  }

  render() {
    let {config} = this.state;
    if (!config) return this.renderConfig();
    let {configs} = this.props;

    let selected_config = configs.find(c => c.id === config);
    return (
      <div id="chat">
        <p>Chat Configuration: <strong>{selected_config.name}</strong></p>
        <div className="btn-group">
          <button onClick={e => this.exportSession()} className="btn btn-default">Export Session</button>
          <button onClick={e => this.sessionFileInputRef.current.click()} className="btn btn-default">Import Session</button>
          <input type="file" accept=".json" style={{display: "none"}} onChange={e => this.importSession(e)} ref={this.sessionFileInputRef} />
        </div>
        {this.renderConvo()}
        {this.renderInput()}
      </div>
    );
  }
}


function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}
